export const environment = {
  production: true,
  apiUrl: 'https://api.hadsup.com',
  front_url: 'https://sales.hadsup.com/',
  googleAnalyticsCode: 'G-XFZDDTFGGH',
  hadsup_home_url:'https://www.hadsup.com/',
  dashboard_url: 'https://app.hadsup.com/',
  mapApi: 'AIzaSyBEPWq6Hd5E0JS0lcpxaYl_Jt-TXY5NPaE',
};
